import { HistoryFetchArgs, HistoryItems, getInquiryHistoryItems } from '../assets/ts/data/inquiry-history'
  import useServerData from './use-server-data'
    
    function useInquiryHistory(fetchArgs: HistoryFetchArgs) {
      const {
        data: HistoryData,
        error: HistoryDataError,
        fetchData: fetchHistoryData,
        isLoading: HistoryDataIsLoading,
    
      } = useServerData<HistoryItems, HistoryFetchArgs>(
        getInquiryHistoryItems,
        fetchArgs
      )
      return {
        HistoryData,
        HistoryDataError,
        HistoryDataIsLoading,
        fetchHistoryData,
        refetch: fetchHistoryData, // Add refetch to the return object
      }
    }
    
    export default useInquiryHistory
    